const generateContent = (params) => {
  return fetch(`api/task/${params.taskId}/generate`, {
    method: 'POST',
    headers: {
      Accept: 'text/event-stream',
      'Content-Type': 'application/json'
    },
    ...params.payload
  })
}

export { generateContent }
